import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { imageCdnAsset } from 'lib/common/url-helpers';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import Booking from 'models/booking';
import { PRINTED_PASS_METHOD } from 'models/validation';
import Brand from 'models/brand';

import AppLink from 'containers/common/app-link';

const propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  booking: PropTypes.instanceOf(Booking).isRequired,
};

const DownloadAppsSection = ({ parkingPass, booking, brand }) => {
  if (!brand.showAppDownloadInformation) { return null; }
  if (!get(booking, 'partner.marketingEligible')) { return null; }
  if (parkingPass.validation.requiredMethods.get(PRINTED_PASS_METHOD)) { return null; }

  return (
    <div className="hidden-print with-bottom-margin">
      <div className="row">
        <div className="col-xs-12">
          <h5 className="h5-sg without-vertical-margin vertical-padding-top-2x vertical-padding-bottom line-height-extra">
            <FormattedMessage
              id="parking-pass.view-in-app"
              defaultMessage="VIEW YOUR PASS ON OUR APP"
            />
          </h5>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-6">
          <AppLink appStore="apple" linkProps={{ c: 'banner_popup' }} className="clearfix">
            <img src={imageCdnAsset('/images/download-buttons/apple-transparent-white-alternate@2x.png')} alt="Apple App Store" />
          </AppLink>
        </div>
        <div className="col-xs-6">
          <AppLink appStore="android" linkProps={{ c: 'banner_popup' }} className="clearfix">
            <img src={imageCdnAsset('/images/download-buttons/android-transparent-white-alternate@2x.png')} alt="Google Play Store" />
          </AppLink>
        </div>
      </div>
    </div>
  );
};

DownloadAppsSection.propTypes = propTypes;

export default DownloadAppsSection;
